import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";
import logo from '../assets/img-1.png'

// import CONFIG from '../../cfg/config';

const odstep: string = '          ';

class Notifier extends React.Component<WithTranslation & WithStyles<typeof styles>, any> {

    closeError = () => {
        window.open('https://www.google.pl/', '_self');
      }

  // componentDidMount() {
  //   this.sendFailure()
  // }

  // async sendFailure() {
  //   try {
  //     let res: ReservationId = await bookService.reservCancel(
  //       {
  //         hotelId: CONFIG.hotelID, 
  //         aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //         aPobytId: 123
  //        }, {})    
  //   } catch (error) {
  //     console.error
  //   } 
  //  }

  //PM 2021-08-17
  //usuniecie disableBackdropClick
  render() {
    const classes = this.props.classes;

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        //fullWidth
        open={true}
        classes={{paper: classes.paper}}
      >
        <DialogTitle disableTypography>
          <Typography variant="h6" component="h2"
            className={classes.lowercase} color='primary'
            style={{ fontSize: "1.25rem" }}
            >
            <b>informacja</b>
          </Typography>
          <hr className={classes.hr} />
        </DialogTitle>
            <DialogContent>
                <div className={classes.pictureContainer}>
                    <ResponsiveImgMaterialUi style={{ margin: "auto", display: "block", position: "relative", top: "50%", transform: "translateY(-50%)", width: "40%" }}
                        xs={logo}
                        md={logo}
                        lg={logo}
                    />
                </div>
                <DialogContentText className={classes.dialogContentText}>
                    Szanowni Państwo
                </DialogContentText>
                <DialogContentText className={classes.dialogContentText}>
                    Trwają prace techniczne
                </DialogContentText>
                <DialogContentText className={classes.dialogContentText}>
                    Strona chwilowa nieczynna
                </DialogContentText>
                <DialogContentText className={classes.dialogContentText}>

                </DialogContentText>
                <DialogContentText className={classes.dialogContentText}>
                    Za utrudnienia przepraszamy
          </DialogContentText>
            </DialogContent>
        <DialogActions>
          <Button variant="outlined" size="small" onClick={() => this.closeError()} color='primary' style={{fontSize: "0.825rem"}}
            //style={{ color: '#3a87ad' }}
            >
            <b>OK</b>
          </Button>
         
        </DialogActions>
      </Dialog>
    );
  }
}




const styles = (theme: Theme) => ({
  dialogContentText: {
    whiteSpace: 'pre' as 'pre',
    textAlign: "center" as "center",
    minHeight: "10px",
    fontSize: "1rem"
  },
  hr: {
    marginTop: '10px'
  },
  lowercase: {
    textTransform: "lowercase" as "lowercase"
  },
  paper: {
      minWidth: "400px"
  },
  pictureContainer: {
    height: "150px",
    position: "relative" as "relative",
    paddingBottom: "16px"
  },
});

export default withTranslation()(withStyles(styles)(Notifier));